import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

/** `<mat-icon svgIcon="app:redeem">`: icons come from Tabler, synced by scripts/icons/sync-icons.mjs. */
export const APP_ICONS_NAMESPACE = "app";

export const resolveAppIcon = (sanitizer: DomSanitizer) =>
  (name: string, namespace: string): SafeResourceUrl | null =>
    namespace === APP_ICONS_NAMESPACE ? sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/app/${name}.svg`) : null;

export const registerAppIcons = (registry: MatIconRegistry, sanitizer: DomSanitizer): (() => void) =>
  () => {
    registry.addSvgIconResolver(resolveAppIcon(sanitizer));
  };
